export default "__VITE_ASSET__GJtiRURC__"